import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'

// Apex Charts imports
import VueApexCharts from 'vue-apexcharts'

// Auth0 imports
import { domain, clientId, audience, scope } from '../auth_config.json'
import { Auth0Plugin } from '@/auth/auth0-plugin'

// Apex Charts
Vue.component('apexchart', VueApexCharts)

// Auth 0
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  scope,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    )
  },
})

Vue.config.productionTip = false

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
